import { ViewingRegion, ViewingRegionDisplayName } from './constants'

export const parseDigits = (input?: string) => (input?.match(/\d+/g) || []).join('')

export const getRegionDisplayName = (key: ViewingRegion): ViewingRegionDisplayName => {
  return ViewingRegionDisplayName[key]
}
